import { ISelectOption } from "src/shared/types/field.types";

export const defaultPageSizeOptions = [10, 25, 50];
export const defaultPageSize = 25;
export const calendarFilterParamsFormat = "YYYY-MM-DDTHH:mm:ss.SSSZ";

export const defaultFilterOption: ISelectOption[] = [
  {
    name: "Все",
    value: "",
  },
];
